import { RecordSummaryRelationDto } from './record-summary-relation.dto';
import { RecordSummaryTrendDto } from './record-summary-trend.dto';

export class RecordSummaryDto {
  relations!: RecordSummaryRelationDto[];
  trend!: RecordSummaryTrendDto;
}
